import { motion, AnimatePresence } from "framer-motion";
import { WifiSlash, ArrowsClockwise } from "@phosphor-icons/react";

interface OfflineBannerProps {
  isOnline: boolean;
  isSyncing: boolean;
  pendingCount: number;
}

export function OfflineBanner({ isOnline, isSyncing, pendingCount }: OfflineBannerProps) {
  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ opacity: 0, y: -24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -24 }}
          transition={{ duration: 0.24, ease: [0.2, 0.8, 0.2, 1] }}
          className="flex items-center justify-center gap-2 px-4 py-1.5 bg-[var(--color-ember-orange)]/10 border-b border-[var(--color-ember-orange)]/20"
        >
          <WifiSlash size={14} className="text-[var(--color-ember-orange)]" />
          <span className="text-xs text-[var(--color-ember-orange)]">
            Offline — changes will sync when reconnected
          </span>
          {pendingCount > 0 && (
            <span className="text-[10px] text-[var(--color-ember-orange)]/70">
              ({pendingCount} pending)
            </span>
          )}
        </motion.div>
      )}

      {isOnline && isSyncing && (
        <motion.div
          initial={{ opacity: 0, y: -24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -24 }}
          transition={{ duration: 0.24, ease: [0.2, 0.8, 0.2, 1] }}
          className="flex items-center justify-center gap-2 px-4 py-1.5 bg-[var(--color-cool-azure)]/10 border-b border-[var(--color-cool-azure)]/20"
        >
          <ArrowsClockwise size={14} className="text-[var(--color-cool-azure)] animate-spin" />
          <span className="text-xs text-[var(--color-cool-azure)]">
            Syncing offline changes...
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
